import React from "react";
import { TOUCH_FEEDBACK_STYLE } from "../../../constants/secondaryCamera";

// Floating control over a camera feed — shared by the positioning slide and the
// active monitoring screen so both switch cameras with the same affordance.
const CameraActionButton = ({ onClick, title, icon: Icon }) => (
  <button
    onClick={onClick}
    title={title}
    style={TOUCH_FEEDBACK_STYLE}
    className="bg-gray-800/50 backdrop-blur-sm p-3 rounded-full border border-gray-700/50 text-white hover:bg-gray-600/70 active:bg-gray-600/70 active:scale-95 transition-transform"
  >
    <Icon className="w-5 h-5" />
  </button>
);

export default CameraActionButton;
